import { apiGetDownloadSearch } from '../apiRequest/others';

const SEARCH_FIELD = {
  type: 'type',
  date: 'date',
};

export const DownloadSearch = {
  data() {
    return {
      searchOptions: {},
    };
  },
  async created() {
    Promise.all([
      this.getSearch({ params: { field: SEARCH_FIELD.type } }),
      this.getSearch({ params: { field: SEARCH_FIELD.date } }),
    ]);
  },
  methods: {
    async getSearch(payload) {
      const res = await apiGetDownloadSearch(payload);
      this.searchOptions = {
        ...this.searchOptions,
        [payload.params.field]: res,
      };
    },
  },
  computed: {
    searchOptionSets() {
      return [
        {
          key: SEARCH_FIELD.type,
          label: this.$t('TYPE'),
          options: this.searchOptions[SEARCH_FIELD.type]
        },
        {
          key: SEARCH_FIELD.date,
          label: this.$t('UPLOAD_DATE'),
          options: this.searchOptions[SEARCH_FIELD.date]
        },
      ];
    },
  },
};
